/**
 * Profile pictures (ADR-079 in `platform`): what the console lets a person send, and what it says
 * when it will not. Pure, for `test/avatar.test.ts`.
 *
 * Only a first check, to spare a round trip for a file that could never be accepted. core-api
 * decodes the picture, refuses a damaged one whatever its type claims, and has the last word.
 * The numbers here mirror its `src/avatars.py`.
 */

export const AVATAR_TYPES = ["image/jpeg", "image/png", "image/webp"] as const;

/** For the file input's `accept`, so the chooser offers only these. */
export const AVATAR_ACCEPT = AVATAR_TYPES.join(",");

/** core-api's `DEFAULT_MAX_UPLOAD_BYTES`. */
export const AVATAR_MAX_BYTES = 10 * 1024 * 1024;

/** Why this file cannot be a profile picture, or `null` to send it. */
export function avatarFileProblem(file: { type: string; size: number }): string | null {
  if (file.size === 0) return "The file is empty. Choose another.";
  if (!(AVATAR_TYPES as readonly string[]).includes(file.type)) {
    return "Choose a JPEG, PNG or WebP picture.";
  }
  if (file.size > AVATAR_MAX_BYTES) return "This picture is too large. Choose one under 10 MB.";
  return null;
}
